<template>
    <v-main fill-height>
        
        <admin-toolbar></admin-toolbar>

        <router-view></router-view>

    </v-main>
</template>

<script>
import AdminToolbar from './global/Toolbar.vue';

export default {
  components: {
    AdminToolbar,
  },
  data() {
    return {};
  },
};
</script>